/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const RepresentativeContractInput = zod.object({
  contractedAt: zod.iso.date(),
  durationMonths: zod.int().min(1),
});

export type RepresentativeContractInput = zod.input<typeof RepresentativeContractInput>;
export type RepresentativeContractInputOutput = zod.output<typeof RepresentativeContractInput>;
